import React from 'react';
import Modal from './Modal';

/**
 * IMPORTANT: Do NOT render this inside another <Modal>.
 * It spawns its own <Modal> internally which creates an invisible overlay
 * that freezes the parent modal at non-100% browser zoom.
 * For confirmations inside a modal, use an inline panel instead.
 * Reference: src/components/common/ACCApplicationCreateModal.js
 */
export const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel = 'Confirm',
  variant = 'danger', // 'danger' | 'warning'
  loading = false,
  error = '',
}) => {
  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={onCancel} className="max-w-sm w-full" zIndex="z-60">
      <div
        className="relative bg-white rounded-2xl warm-tactile-shadow border border-amber-100/30 p-6 w-full"
        style={{ paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}
      >
        <button
          type="button"
          onClick={onCancel}
          aria-label="Close confirmation dialog"
          className="absolute top-4 right-4 w-10 h-10 rounded-full hover:bg-section-bg flex items-center justify-center text-primary-dark"
        >
          <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>close</span>
        </button>
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4
          ${variant === 'danger' ? 'bg-red-50' : 'bg-amber-50'}`}
        >
          <span
            className={`material-symbols-outlined ${variant === 'danger' ? 'text-red-500' : 'text-amber-500'}`}
            style={{ fontSize: '24px' }}
          >
            warning
          </span>
        </div>
        <h3 className="font-bold text-primary-dark text-lg mb-2">{title}</h3>
        <p className="text-slate-500 text-sm font-medium mb-6">{message}</p>
        {error && (
          <p
            role="alert"
            className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3 text-sm font-medium mb-4"
          >
            {error}
          </p>
        )}
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="flex-1 border border-slate-200 hover:bg-cream text-slate-700
              font-semibold rounded-full px-4 py-2.5 text-sm transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 font-semibold rounded-full px-4 py-2.5 text-sm
              transition-colors text-white disabled:opacity-50
              ${
                variant === 'danger'
                  ? 'bg-red-600 hover:bg-red-500'
                  : 'bg-amber-600 hover:bg-amber-500'
              }`}
          >
            {loading ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};
